import { render, staticRenderFns } from "./PublicHarjoitukset.vue?vue&type=template&id=6325b47f"
import script from "./PublicHarjoitukset.vue?vue&type=script&lang=js"
export * from "./PublicHarjoitukset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports